// Import Event type for the new combined type
import { z } from "zod";

import {
  BookingSchema,
  CreditTxUsageMetaSchema,
  EventSchema,
  EventSessionSchema,
  InvitationSchema,
  LocationSchema,
  OrgSchema,
  TicketTierSchema,
  UserSchema
} from "../models";
import { CreditTxWithMetaSchema } from "./credit";
import { BookingAnswerInputSchema, BookingAnswerWithQuestionSchema } from "./event";

export enum PaymentMethodEnum {
  CREDIT = "credit",
  BANK_TRANSFER = "bank-transfer"
  // CARD = "card"
}

// Create event booking schema
export const CreateBookingSchema = BookingSchema.omit({
  id: true,
  userId: true,
  status: true,
  createdAt: true,
  updatedAt: true
}).extend({
  paymentMethod: z.nativeEnum(PaymentMethodEnum).default(PaymentMethodEnum.CREDIT),
  bringFriend: z.boolean(),
  answers: z.array(BookingAnswerInputSchema).default([])
});
export type CreateBooking = z.infer<typeof CreateBookingSchema>;

// Update booking schema
export const UpdateBookingSchema = BookingSchema.partial().omit({
  id: true,
  userId: true,
  createdAt: true,
  updatedAt: true
});
export type UpdateBooking = z.infer<typeof UpdateBookingSchema>;

export enum BookingStatusFilterEnum {
  ALL = "ALL",
  PENDING = "PENDING",
  UPCOMING = "UPCOMING",
  PAST = "PAST",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED"
}
export const BookingStatusFilterSchema = z.nativeEnum(BookingStatusFilterEnum);
export type BookingStatusFilter = z.infer<typeof BookingStatusFilterSchema>;
export const GetBookingsFiltersSchema = z.object({
  status: BookingStatusFilterSchema.optional().default(BookingStatusFilterEnum.UPCOMING)
});
export type GetBookingsFilters = z.infer<typeof GetBookingsFiltersSchema>;

// Booking with event information schema
export const BookingWithDetailSchema = BookingSchema.extend({
  ticketTier: TicketTierSchema.extend({
    eventSession: EventSessionSchema.extend({
      event: EventSchema.extend({
        host: OrgSchema,
        location: LocationSchema.optional().nullable()
      })
    })
  }),
  user: UserSchema,
  invitations: z.array(InvitationSchema.extend({ invitee: UserSchema.optional().nullable() })).default([]),
  creditTxUsageMeta: CreditTxUsageMetaSchema.extend({
    creditTx: CreditTxWithMetaSchema
  })
    .optional()
    .nullable(),
  answers: z.array(BookingAnswerWithQuestionSchema).default([])
});
export type BookingWithDetail = z.infer<typeof BookingWithDetailSchema>;

export const BookingRespSchema = BookingWithDetailSchema.extend({
  payment: z
    .object({
      checkoutUrl: z.string(),
      qrCode: z.string()
    })
    .optional()
    .nullable()
});
